import axios from 'axios';
import Helpers from './Helpers';

let endpoints = {
  cart: {
    clear: '/cart/clear.json',
    get: '/cart.json',
    add: '/cart/add.js',
    change: '/cart/change.js',
    update: '/cart/update.js'
  },
  product: {
    get: '/products/[handle].json',
    getCustom: '/products/[handle]?view=json'
  }
};

export default class AjaxApi {
  static async getCart(state = false) {
    let rootURL = state ? state.rootURL : '';
    let result = await axios.get(rootURL + Helpers.getEndpoint(endpoints.cart.get));
    return result.data;
  }

  static async addToCart(options, state = false) {
    let rootURL = state ? state.rootURL : '';
    let result = await axios.post(rootURL + Helpers.getEndpoint(endpoints.cart.add), options);
    return result.data;
  }

  static async changeCart(options, state = false) {
    let rootURL = state ? state.rootURL : '';
    let result = await axios.post(rootURL + Helpers.getEndpoint(endpoints.cart.change), options);
    return result.data;
  }

  static async updateCart(options, state = false) {
    let rootURL = state ? state.rootURL : '';
    let result = await axios.post(rootURL + Helpers.getEndpoint(endpoints.cart.update), options);
    return result.data;
  }

  static async emptyCart(options, state = false) {
    let rootURL = state ? state.rootURL : '';
    let result = await axios.post(rootURL + Helpers.getEndpoint(endpoints.cart.clear), options);
    return result.data;
  }

  static async updateCartItem(id, quantity, props = {}, state = false) {
    return await AjaxApi.changeCart(
      {
        line: `${id}`,
        quantity: quantity,
        properties: props
      },
      state
    );
  }

  static async removeCartItem(id) {
    return await AjaxApi.updateCartItem(id, 0);
  }

  static async getProduct(handle, state = false) {
    let rootURL = state ? state.rootURL : '';
    let endpoint = endpoints.product.get.replace('[handle]', handle);
    let result = await axios.get(rootURL + Helpers.getEndpoint(endpoint));
    return result.data.product;
  }

  static async getCustomProduct(handle, state = false) {
    let rootURL = state ? state.rootURL : '';
    let endpoint = endpoints.product.getCustom.replace('[handle]', handle);
    let result = await axios.get(rootURL + Helpers.getEndpoint(endpoint), { responseType: 'json' });
    return typeof result.data === 'object' ? result.data : JSON.parse(result.data);
  }
}
